import ExpandableAuto from './auto.vue'

export default ExpandableAuto
export { default as ExpandableAuto } from './auto.vue'
